
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11417",
                "data-name": "矩形 11417",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.381 0)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_354",
        "data-name": "蒙版组 354",
        "class": "cls-2",
        "transform": "translate(0.381 0)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "组_8148",
            "data-name": "组 8148",
            "transform": "translate(2.381 2.381)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "icon-test_1"
              },
              "children": [
                {
                  "tag": "path",
                  "attrsMap": {
                    "id": "路径_7771",
                    "data-name": "路径 7771",
                    "class": "cls-3",
                    "d": "M38.89,22.161a.654.654,0,0,1,.663.663V38.89a.654.654,0,0,1-.663.663H22.824a.654.654,0,0,1-.663-.663V22.824a.654.654,0,0,1,.663-.663H38.89m0-.828H22.824a1.484,1.484,0,0,0-1.491,1.491V38.89a1.484,1.484,0,0,0,1.491,1.491H38.89a1.484,1.484,0,0,0,1.491-1.491V22.824A1.484,1.484,0,0,0,38.89,21.333Z",
                    "transform": "translate(-21.333 -21.333)"
                  }
                },
                {
                  "tag": "path",
                  "attrsMap": {
                    "id": "路径_7772",
                    "data-name": "路径 7772",
                    "class": "cls-3",
                    "d": "M252.6,351.6a5.135,5.135,0,1,1,5.135-5.135A5.16,5.16,0,0,1,252.6,351.6Zm0-9.441a4.306,4.306,0,1,0,4.306,4.306A4.33,4.33,0,0,0,252.6,342.161Z",
                    "transform": "translate(-243.077 -335.122)"
                  }
                },
                {
                  "tag": "path",
                  "attrsMap": {
                    "id": "路径_7773",
                    "data-name": "路径 7773",
                    "class": "cls-3",
                    "d": "M38.188,128.908H37.36a2.37,2.37,0,0,0-2.319-2.319v-.828A3.2,3.2,0,0,1,38.188,128.908ZM25.6,121.7H44.482v.828H25.6Zm2.443-2.236h1.9v.828h-1.9Zm5.466,0h1.9v.828h-1.9Zm3.313,0h1.9v.828h-1.9Zm3.313,0h1.9v.828h-1.9Z",
                    "transform": "translate(-25.517 -117.562)"
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  